module.exports = __webpack_public_path__ + "static/media/hiso-bus-rental-menu-phone-2.3e9b23a2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/hiso-bus-rental-menu/hiso-bus-rental-menu-phone-2.svg
// module id = 373
// module chunks = 57